<script>
    import TableToggle from "../../../Components/Common/TableToggle.svelte";
    import {
        getFormatDate,
        getHospitalType,
        getText,
    } from "../../../Utils/utilFunctions.svelte";
    import { isEnvNewOrApp } from "../../../Utils/utilRoute.svelte";
    import { showError } from "../../../Utils/utilFunctions.svelte"
    import { apiMethods } from "../../../Services/index.svelte";
    import CardLayout from "../../../Components/Common/CardLayout.svelte";

    export let hospitalDetails = {};
    export let reloadHospital = () => {};

    $: displayAddress = _getDisplayAddress(hospitalDetails);

    const _getDisplayAddress = (hospital) => {
        const { address, postcode, state, suburb } = hospital;

        let displayAddress = "";

        if (address) displayAddress += address;

        if (suburb) {
            if (displayAddress) displayAddress += ", ";
            displayAddress += suburb;
        }

        if (state) {
            if (displayAddress) displayAddress += ", ";
            displayAddress += state;
        }

        if (postcode) {
            if (displayAddress) displayAddress += ", ";
            displayAddress += postcode;
        }

        return displayAddress;
    };
</script>

<CardLayout title="Hospital Details">
    <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex gap-x-2">
                <p class="title">Name:</p>
                <p class="content">{getText(hospitalDetails.name)}</p>
            </div>

            <div class="flex gap-x-2">
                <p class="title">Type:</p>
                <p class="content">
                    {getHospitalType(hospitalDetails.hospitalType)}
                </p>
            </div>

            <div class="flex gap-x-2">
                <p class="title">Provider No.:</p>
                <p class="content">
                    {getText(hospitalDetails.providerNumber)}
                </p>
            </div>
            {#if isEnvNewOrApp()}
                <div class="flex flex-row gap-x-2">
                    <p class="title">Has No-Gap Program:</p>
                    <p class="content">
                        <TableToggle 
                            valueKey= "isNoGapProgram",
                            row={hospitalDetails}
                            clickFunction={async (hospital, e) => {
                                e.stopPropagation();
                                hospital.isNoGapProgram = !hospital.isNoGapProgram;
                                await apiMethods.putMethod
                                    .updateHospitalIsGapProgram(hospital.id, hospital.isNoGapProgram ? 1 : 0)
                                    .then((res) => {
                                        if (res.error) showError(res.error);
                                        reloadHospital();
                                    });
                            }}>
                        </TableToggle>
                    </p>
                </div>
            {/if}
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex gap-x-2">
                <p class="title">Contact No.:</p>
                <p class="content">
                    {hospitalDetails.phone
                        ? getText(hospitalDetails.phone)
                        : "-"}
                </p>
            </div>

            <div class="flex gap-x-2">
                <p class="title">Email:</p>
                {#if hospitalDetails.email}
                    <a
                        href="mailto:{hospitalDetails.email}"
                        target="_blank"
                        class="content break-all hover:text-[#8A3ED7] hover:underline hover:font-bold"
                    >
                        {getText(hospitalDetails.email)}
                    </a>
                {:else}
                    <p class="content">-</p>
                {/if}
            </div>

            <div class="flex gap-x-2">
                <p class="title">Address:</p>
                <p class="content">{displayAddress}</p>
            </div>

            <div class="flex gap-x-2">
                <p class="title">Fax:</p>
                <p class="content">
                    {hospitalDetails.fax
                        ? getText(hospitalDetails.fax)
                        : "-"}
                </p>
            </div>
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex gap-x-2">
                <p class="title">Create Date:</p>
                <p class="content">
                    {getFormatDate(hospitalDetails.createdDate)}
                </p>
            </div>

            <div class="flex gap-x-2">
                <p class="title">Last Update Date:</p>
                <p class="content">
                    {getFormatDate(hospitalDetails.updatedDate)}
                </p>
            </div>
        </div>
    </div>
</CardLayout>

<style>
    .title {
        width: 150px;
    }

    .content {
        width: calc(100% - 150px);
    }

    .transition {
        transition: 0.5s linear;
    }
</style>
